export default __webpack_public_path__ + "static/media/THE_DAILY_RECORD.490745ee.png";